import { createFileRoute } from '@tanstack/react-router';

import { ensureRecord, requirePermission } from '@/app/guards';
import { EditDealPage, dealQuery } from '@/features/deals';
import { NotFoundView } from '@/features/shell';

export const Route = createFileRoute('/_app/deals/$dealId_/edit')({
  staticData: { crumb: 'nav.deals', crumbTo: '/deals' },
  beforeLoad: ({ context }) => requirePermission(context.queryClient, 'deal.view', 'Deals'),
  loader: async ({ context, params }) => {
    const deal = await ensureRecord(context.queryClient.query({ ...dealQuery(params.dealId), staleTime: 'static' }));
    return { crumb: deal.number };
  },
  notFoundComponent: function EditDealNotFound() {
    const { dealId } = Route.useParams();
    return <NotFoundView reference={dealId} />;
  },
  component: function EditDeal() {
    const { dealId } = Route.useParams();
    return <EditDealPage dealId={dealId} />;
  },
});
